export enum ChartDefaults {
    PLUGIN_TOLERANCE_LINE = 'toleranceLinePlugin',

    TOLERANCE_OPTIONS = 'toleranceOptions',
    TOLERANCE_SCALE = 'scaleTolerance',
    TOLERANCE_SHOW = 'showToleranceLine',

    DEFAULT_TOLERANCE_LINE_COLOR = '#35A775'
}
